import React from 'react'
import corporatemeetinghal from "../images/corporate_meeting hall.jpg";
import Corporatemeeting from "../images/Corporate Meeting_ Berhampore.jpg";
import corporatemeetingbook from "../images/corporate meeting_MURSHIDABAD MILAN 2025.jpg";



function CorporateSlider() {
  return (
    <div>
        <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={corporatemeetinghal} className="d-block w-100" alt="corporatemeetinghal"/>
      <div className="carousel-caption d-none d-md-block">
        <h2><b>Vila's Club Resort</b></h2>
        <h6>Best Corporate Hall Booking Availavle <b><a style={{color:"white"}} href='tel: 9046258703'>+91 9046258703</a></b> </h6>
      </div>
    </div>
    <div className="carousel-item">
      <img src={Corporatemeeting} className="d-block w-100" alt="Corporatemeeting"/>
      <div className="carousel-caption d-none d-md-block">
      <h2><b>Vila's Club Resort</b></h2>
      <h6>Best Corporate Hall Booking Availavle <b><a style={{color:"white"}} href='tel: 9046258703'>+91 9046258703</a></b> </h6>
      </div>
    </div>
    <div className="carousel-item">
      <img src={corporatemeetingbook} className="d-block w-100" alt="corporatemeetingbook"/>
      <div className="carousel-caption d-none d-md-block">
      <h2><b>Vila's Club Resort</b></h2>
      <h6>Best Corporate Hall Booking Availavle <b><a style={{color:"white"}} href='tel: 9046258703'>+91 9046258703</a></b> </h6>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default CorporateSlider